# Currently terribly bound to ui-select, but can be made generic in refactoring
module.exports = (
  DynamicTabManager,
  Keys,
  $parse
) ->
  {
    require: [ 'dynamicTabTarget', 'uiSelect' ]
    restrict: 'A'
    controller: ( $scope, $element ) ->
      # We need the `isActive` and `focus` methods on the controller, but they require
      # the uiSelectController, which is only available to the link function.
      # So we declare a controller that does nothing, and the link function will inject
      # the methods required
      return

    link: ($scope, el, attrs, controllers ) ->
      if angular.isDefined( attrs.tabTargetActive )
        isActive = $parse( attrs.tabTargetActive )
      else
        isActive = () -> true

      [ ownController, uiSelectController ] = controllers

      ownController.isActive = () ->
        isActive( $scope )

      ownController.leave = () ->
        uiSelectController.close( true )

      ownController.focus = () ->
        uiSelectController.focusser.focus()

      el.on 'keydown', ( event ) ->
        if event.which == Keys.TAB
          event.preventDefault()
          event.stopPropagation()

          if event.shiftKey
            DynamicTabManager.tabBackward( el )
          else
            DynamicTabManager.tabForward( el )

        return

      $scope.$on '$destroy', ->
        el.off 'keydown'
        return

  }
